import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import caseExternalContactService from "../../services/caseExternalContactService";

const useCaseExternalContactTypes = () => useQuery(
    [queryKeys.caseExternalContactTypes],
    () => caseExternalContactService.getExternalContactTypes(),
    {
        staleTime: Infinity
    }
)

export default useCaseExternalContactTypes